import { AvailableLanguages } from '@agro-club/agroclub-shared'
import { useTranslation } from 'react-i18next'

const useLanguage = () => {
  const { i18n } = useTranslation()
  return i18n.language as AvailableLanguages
}

export default useLanguage
